import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

// Custom hook to use the authentication context
export const useAuth = () => {
  return useContext(AuthContext);
};

// AuthProvider component
export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(() => localStorage.getItem('accessToken') || null);
  const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem('refreshToken') || null);
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('accessToken'));


  // Function to remove token (for logout)
  const removeTokens = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setAccessToken(null);
    setRefreshToken(null);
    setIsAuthenticated(false);
  };

  const storeTokens = (newAccessToken, newRefreshToken) => {
    localStorage.setItem('accessToken', newAccessToken); 
    localStorage.setItem('refreshToken', newRefreshToken); 
    setAccessToken(newAccessToken);
    setRefreshToken(newRefreshToken); 
    setIsAuthenticated(true);
  };

  return (
    <AuthContext.Provider value={{ accessToken, refreshToken, storeTokens, removeTokens, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
